/** Maps GET /me profile into the legacy array shape Profile.jsx expects. */
export function legacyUserFromMe(me) {
  const phone = me.phone;
  const addr = me.address;
  return [
    {
      fname: me.firstName,
      mname: me.middleName,
      lname: me.lastName,
      email: me.email,
      profilepic: null,
      jobtitle: me.jobTitle,
      phones: phone
        ? [
            {
              phoneid: phone.id,
              phonenumber: phone.number,
              countrycode: phone.countryCode,
              verificationstatus: phone.verificationStatus,
            },
          ]
        : [
            {
              phoneid: 0,
              phonenumber: '',
              verificationstatus: 'Unverified',
            },
          ],
      addresses: addr
        ? [
            {
              addressline1: addr.line1,
              addressline2: addr.line2,
              city: addr.city,
              state: addr.state,
              zip: addr.zip,
              country: addr.country,
              latitude: addr.latitude,
              longitude: addr.longitude,
              addresstype: addr.type,
            },
          ]
        : [],
    },
  ];
}

export function legacyServicesFromOfferings(offerings, catalog) {
  const nameById = {};
  (catalog || []).forEach((s) => {
    nameById[s.id || s.serviceid] = s.name;
  });
  return (offerings || []).map((s) => ({
    serviceid: s.serviceId,
    name: nameById[s.serviceId] || '',
    experiencelevel: s.experienceLevel,
    yearofexperience: s.yearsOfExperience,
    hourlyrate: s.hourlyRate,
    currency: s.currency,
    serviceproviderid: s.id,
  }));
}
